"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
var Text_1 = __importDefault(require("../../Text/Text"));
var layout_1 = require("../../layout");
var icons_1 = require("../../../icons");
var data_display_1 = require("../../data-display");
var styles = {
    container: react_1.css({
        position: 'relative',
        height: 36,
        alignItems: 'center',
        borderRadius: 6,
        paddingRight: 8,
        color: "var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
    }),
    activeContainer: react_1.css({
        background: "var(" + variables_1.Gradient.Primary.PRIMARY_2 + ")",
        color: "var(" + variables_1.RootColor.White + ")",
    }),
    enabledContainer: react_1.css({
        cursor: 'pointer',
        ':hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.DARK_3 + ")",
        },
    }),
    disabledContainer: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.DARK_1 + ")",
        cursor: 'not-allowed',
    }),
    icon: react_1.css({
        minWidth: 20,
        minHeight: 20,
    }),
    text: react_1.css({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textDecoration: 'none',
        flex: 1,
    }),
    lockIconWrapper: react_1.css({
        position: 'absolute',
        display: 'grid',
        placeItems: 'center',
        width: 10.8,
        height: 10.8,
        left: 22.5,
        bottom: 2.7,
    }),
    lockIcon: react_1.css({
        color: "var(" + variables_1.ThemeColor.Primary.LIGHT_3 + ")",
    }),
    fontSizePx: react_1.css({
        fontSize: '16px',
    }),
};
var RELEASE_STATUS_CONFIG_MAPPING = {
    alpha: {
        iconIndicator: "var(" + variables_1.RootColor.Orange.DEFAULT + ")",
        badgeColor: 'orange',
        badgeText: 'ALPHA',
    },
    beta: {
        iconIndicator: "var(" + variables_1.RootColor.Teal.DEFAULT + ")",
        badgeColor: 'teal',
        badgeText: 'BETA',
    },
};
var SidebarItem = function (_a) {
    var SidebarIcon = _a.icon, active = _a.active, title = _a.title, disabled = _a.disabled, _b = _a.releaseStatus, releaseStatus = _b === void 0 ? 'prod' : _b, _c = _a.usePx, usePx = _c === void 0 ? false : _c;
    var releaseStatusConig = RELEASE_STATUS_CONFIG_MAPPING[releaseStatus];
    return (react_1.jsx(layout_1.Flex, { direction: "row", gap: 4, css: [
            styles.container,
            active ? styles.activeContainer : undefined,
            disabled ? styles.disabledContainer : styles.enabledContainer,
        ], alignItems: "center", title: title, disabled: disabled },
        react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", css: { width: 36, height: 36, flexShrink: 0 } },
            react_1.jsx(SidebarIcon, { width: 20, height: 20, css: styles.icon, color: "var(" + (disabled ? variables_1.RootColor.Gray.DARK_1 : variables_1.RootColor.White) + ")" }),
            disabled && (react_1.jsx("div", { css: styles.lockIconWrapper },
                react_1.jsx(icons_1.Lock, { size: 9, css: styles.lockIcon }))),
            releaseStatusConig ? (react_1.jsx("div", { css: styles.lockIconWrapper },
                react_1.jsx("div", { css: {
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: releaseStatusConig.iconIndicator,
                    } }))) : null),
        react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "center", css: { overflow: 'hidden', flex: 1 } },
            react_1.jsx(Text_1.default.Body, { size: "md", color: "inherit", css: [styles.text, usePx ? styles.fontSizePx : undefined] }, title),
            releaseStatusConig ? (react_1.jsx(data_display_1.Badge, { mode: "dark", color: releaseStatusConig.badgeColor }, releaseStatusConig.badgeText)) : null)));
};
SidebarItem.displayName = 'Sidebar.Item';
exports.default = SidebarItem;
